module.exports = __webpack_public_path__ + "static/media/fpo-tile.aeb43419.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/fpo-tile.png
// module id = 459
// module chunks = 0